import { Modal } from "@/app/(components)/Basic/Modal";
import { FeedPostDto } from "@/api/posts/types";
import nftsApi from "@/api/nfts/client";
import { useQuery } from "@tanstack/react-query";
import { FeedUpsert } from "../../FeedUpsert";
import { useState } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  feedPost: FeedPostDto;
}

const FeedRepostModal = ({ isOpen, onClose, feedPost }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { data: enrichedRepost } = useQuery({
    //eslint-disable-next-line
    queryKey: ["enrichedRepost", feedPost.id],
    queryFn: async () => {
      const enrichedRepost = await nftsApi.enrichWithNft<FeedPostDto, "nft">(
        [feedPost],
        {
          attachedNftId: {
            name: "attachedNft",
            addressGetter: (item) => item.attachedNftId!,
          },
        },
      );
      return enrichedRepost[0];
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="max-w-[720px] w-11/12"
      disableClose={isLoading}
      smallPadding
      title="Repost"
      hasCloseButton
    >
      <FeedUpsert
        id="feed-repost"
        hideAttachActions
        repost={enrichedRepost}
        onSuccess={() => {
          onClose();
          setIsLoading(false);
        }}
        onError={() => setIsLoading(false)}
        onSubmit={() => setIsLoading(true)}
        forceLightTheme
      />
    </Modal>
  );
};

export default FeedRepostModal;
